import PropTypes from 'prop-types';
import React from 'react';
import { Notification } from '@selfdetermine/react-elements';
import { v4 } from 'uuid';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Builds the toast props needed to properly display the new toast.
 *
 * @param {string} [type] - Type of toast (`'success'`, `'warning'`, `'danger'`, `'info'`, `null`)
 * @param {string|object} toast - Toast message or toast object
 * @param {string} [toast.title] - Title of toast message
 * @param {string} [toast.description] - Description of toast
 *
 * @returns {object} Toast data
 */

var makeToast = function makeToast(type, toast) {
  return _objectSpread2({
    type: type,
    id: v4()
  }, typeof toast === "string" ? {
    title: toast
  } : toast);
};
/**
 * Toasts subscription manager. This component provides methods to "subscribe"/"unsubscribe"
 * to a feed of toasts. It also provides methods for publishing new toasts to all
 * current subscribers.
 */


var ToastsManager = /*#__PURE__*/function () {
  function ToastsManager() {
    _classCallCheck(this, ToastsManager);

    this.subscribers = [];
  }
  /**
   * Subscribes the given function to the toasts feed.
   *
   * @param {function} subscriber - subscription function
   */


  _createClass(ToastsManager, [{
    key: "subscribe",
    value: function subscribe(subscriber) {
      this.subscribers.push(subscriber);
    }
    /**
     * Unsubscribes from the toasts feed.
     *
     * @param {function} subscriber - subscription function
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(subscriber) {
      this.subscribers = this.subscribers.filter(function (currentSubscriber) {
        return currentSubscriber !== subscriber;
      });
    }
    /**
     * Publishes a default toast.
     *
     * @param {string|object} payload - Toast content
     */

  }, {
    key: "add",
    value: function add(payload) {
      this.subscribers.forEach(function (subscriber) {
        return subscriber(makeToast(null, payload));
      });
    }
    /**
     * Publishes a successful toast.
     *
     * @param {string|object} payload - Toast content
     */

  }, {
    key: "success",
    value: function success(payload) {
      this.subscribers.forEach(function (subscriber) {
        return subscriber(makeToast("success", payload));
      });
    }
    /**
     * Publishes a danger toast.
     *
     * @param {string|object} payload - Toast content
     * @param {object} [error] - error instance
     */

  }, {
    key: "danger",
    value: function danger(payload, error) {
      var _error$graphQLErrors, _error$graphQLErrors$, _error$graphQLErrors$2;

      var errorMessage = error === null || error === void 0 ? void 0 : (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : (_error$graphQLErrors$ = _error$graphQLErrors.map(function (_ref) {
        var message = _ref.message;
        return message;
      })) === null || _error$graphQLErrors$ === void 0 ? void 0 : (_error$graphQLErrors$2 = _error$graphQLErrors$.filter(Boolean)) === null || _error$graphQLErrors$2 === void 0 ? void 0 : _error$graphQLErrors$2.join(" ");
      var toastPayload = typeof payload === "string" ? {
        title: payload,
        description: errorMessage
      } : _objectSpread2({
        description: errorMessage
      }, payload);
      this.subscribers.forEach(function (subscriber) {
        return subscriber(makeToast("danger", toastPayload));
      });
    }
    /**
     * Publishes a warning toast.
     *
     * @param {string|object} payload - Toast content
     */

  }, {
    key: "warning",
    value: function warning(payload) {
      this.subscribers.forEach(function (subscriber) {
        return subscriber(makeToast("warning", payload));
      });
    }
  }]);

  return ToastsManager;
}(); // Export a singleton of the ToastsManager so there's only one instance of it available.


var Toasts = new ToastsManager();
/**
 * Hook that calls the provided callback anytime a new toast is added.
 * @param {function} callback - Function to call when a new toast is added.
 */

var useToasts = function useToasts(callback) {
  React.useEffect(function () {
    if (typeof callback === "function") {
      Toasts.subscribe(callback);
    }

    return function () {
      Toasts.unsubscribe(callback);
    };
  }, [Toasts.subscribe, Toasts.unsubscribe, callback]);
};
/**
 * Individual toast component. Displays the given toast and as long as
 * it's not a "danger" toast then it automatically clears itself after
 * 5 seconds.
 */

var Toast = function Toast(_ref2) {
  var toast = _ref2.toast;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  React.useEffect(function () {
    // If the toast is 'danger' then we want to ensure users
    // acknowledge it, so we won't close it until they do.
    if (toast.type !== "danger") {
      var timeout = setTimeout(function () {
        setVisible(false);
      }, 5000);
      return function () {
        return clearTimeout(timeout);
      };
    }

    return null;
  }, [setVisible]);

  if (!visible) {
    return false;
  }

  return /*#__PURE__*/React.createElement(Notification, {
    type: toast.type,
    key: toast.id,
    style: {
      maxWidth: "100%",
      width: "max-content"
    }
  }, !!toast.title && /*#__PURE__*/React.createElement("strong", null, toast.title), !!toast.description && /*#__PURE__*/React.createElement("div", null, toast.description));
};

Toast.propTypes = {
  toast: PropTypes.shape({
    description: PropTypes.string,
    id: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string
  })
};
Toast.defaultProps = {
  toast: {}
};
/**
 * "Toasts" are short messages that provide feedback to the user. They are an important
 * part of the feedback loop to the user as it tells them whether an action they took
 * was successful or not. The term "toast" is because these messages pop-up similar to
 * toast popping out of a toaster when it's done.
 *
 * This is used alongside `Toasts` which is what can be used to add toast messages.
 *
 * Just add the `<Toaster />` component somewhere within the app, generally at the top level.
 *
 * Then within the app, whenever a toast should be added, use one of the `Toasts` methods to
 * add the message.
 *
 * ```
 * import { Toaster, Toasts } from '@selfdetermine/react-toasts'
 *
 * const App = () => {
 *   const saveTheForm = () => {
 *     saveIt()
 *       .then(() => Toasts.success('Form submitted successfully!'))
 *       .error(() => Toasts.error('Failed to submit form!'))
 *   }
 *
 *   return (
 *     ...
 *     <Toaster />
 *     ...
 *   )
 * }
 * ```
 *
 * ## Toasts
 *
 * Each toast method accepts a single argument. A *string* or an *object* containing
 * a "title" and/or "description" properties. Use the object notation if you need a
 * more detailed toast.
 *
 * ### `Toasts.add`
 *
 * Adds a generic toast message.
 *
 * ```
 * import { Toasts } from '@selfdetermine/react-toasts'
 *
 * Toasts.add('Basic toast message')
 * Toasts.add({ title: 'Toast title', description: 'Description of the toast' })
 * ```
 *
 * ### `Toasts.success`
 *
 * Adds a success toast message. Use whenever a user's action was successful.
 *
 * ```
 * import { Toasts } from '@selfdetermine/react-toasts'
 *
 * Toasts.success('Hooray! It worked!')
 * Toasts.success({ title: 'Toast title', description: 'Description of the toast' })
 * ```
 *
 * ### `Toasts.warning`
 *
 * Adds a warning toast message. Use whenever the user needs to be warned about something.
 *
 * ```
 * import { Toasts } from '@selfdetermine/react-toasts'
 *
 * Toasts.warning('Be careful')
 * Toasts.warning({ title: 'Toast title', description: 'Description of the toast' })
 * ```
 *
 * ### `Toasts.danger`
 *
 * Adds a danger toast message. Use whenever something goes wrong that shouldn't.
 *
 * ```
 * import { Toasts } from '@selfdetermine/react-toasts'
 *
 * Toasts.danger("Oops it didn't work")
 * Toasts.danger({ title: 'Toast title', description: 'Description of the toast' })
 * ```
 */

var Toaster = /*#__PURE__*/React.memo(function () {
  var _React$useState3 = React.useState([]),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      toasts = _React$useState4[0],
      setToasts = _React$useState4[1];

  useToasts(function (newToast) {
    return setToasts([newToast].concat(_toConsumableArray(toasts)));
  });
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      zIndex: 123456789,
      bottom: "2rem",
      right: "2rem",
      maxWidth: "calc(100vw - 4rem)",
      width: "30rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end"
    }
  }, toasts.map(function (toast) {
    return /*#__PURE__*/React.createElement(Toast, {
      toast: toast,
      key: toast.id
    });
  }));
});

export { Toaster, Toasts, useToasts };
